<template>
    <price-tag-shell :context="context">
        <div class="pt-row pt-row--top">
            <div class="pt-column pt-grow">
                <div class="pt-headline">{{ headline }}</div>
                <div class="pt-row">
                    <span class="pt-big-number">
                        <template v-if="fieldsByKey.percent && editable">
                            <price-tag-value v-bind="bindField('percent')" />%
                        </template>
                        <template v-else>{{ formatPercent(firstTier.discountPercent) }}</template>
                    </span>
                    <span class="pt-medium">{{
                        isFree ? tagText('offFree') : tagText('off')
                    }}</span>
                </div>
                <div class="pt-medium">
                    <template v-if="editable">
                        {{ tagText('buy') }}
                        <price-tag-value v-bind="bindField('nthItem')" />
                    </template>
                    <template v-else>{{ tagText('whenYouBuy', { n: nthItem }) }}</template>
                </div>
            </div>
            <div class="pt-divider" />
            <div class="pt-column pt-grow">
                <price-tag-product :product="context.product" size="medium" />
                <div v-if="context.isMixAndMatch" class="pt-chip">
                    {{ tagText('mixAndMatch') }}
                </div>
            </div>
        </div>
    </price-tag-shell>
</template>

<script setup>
import { computed } from 'vue';
import {
    priceTagLayoutProps,
    priceTagLayoutEmits,
    usePriceTagLayout,
} from '@/js/composables/usePriceTagLayout';

const props = defineProps(priceTagLayoutProps);
const emit = defineEmits(priceTagLayoutEmits);

const { bindField, tagText, formatPercent, ordinal } = usePriceTagLayout(props, emit);

const firstTier = computed(() => props.context.tiers[0] || {});

const nthItem = computed(() => props.values.nthItem || firstTier.value.nthItem);

const isFree = computed(() => firstTier.value.discountPercent === 100);

const headline = computed(() =>
    tagText(isFree.value ? 'nthProduct' : 'cheaperItem', { ordinal: ordinal(nthItem.value) })
);
</script>

<style lang="scss" scoped>
@import '@style/price-tags/price-tag-layout';
</style>
